import React from 'react';
import { makeStyles } from '@mui/styles';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import { ThemeOptions, Theme } from '@mui/material';
import { chipTypes, fieldTypes } from '@/helpers/constants';
import HighlightText from '../../HighlightText/HighlightText';
import UniversalChip from '../UniversalChip/UniversalChip';

const useStyles = makeStyles((theme:ThemeOptions & Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'start',
    flexWrap: 'wrap',
    listStyle: 'none',
    margin: 0,
    boxShadow: 'none',
  },
  rootDisabled: {
    backgroundColor: theme?.cartTheme?.contentBackgroundColor,
    height: '95%',
    marginTop: '-5px',
  },
  chip: {
    margin: theme?.spacing?.(0.5) ?? '4px',
  },
  counterChip: {
    margin: theme?.spacing?.(0.5) ?? '4px',
  },
  counterRoot: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'end',
    width: '10%',
  },
  chipRoot: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'start',
    width: '90%',
  },
  chipRootDisabled: {
    margin: '15px',
  },
}));

type ChipDataType = { key: string, label: string };

interface ArrayChipsProps {
  id: string;
  handleDelete: (data: ChipDataType) => void
  chipData: ChipDataType[];
  disabled: boolean;
  counter?: number;
  openSeriesDialog?: () => void;
  fieldPath?: string[];
}

const ArrayChips: React.FC<ArrayChipsProps> = (props) => {
  const { id, chipData, handleDelete, disabled, counter = 0, openSeriesDialog = () => { }, fieldPath = [] } = props;
  const classes = useStyles();

  const handleOpenDetails = () => {
    openSeriesDialog();
  };

  const getIndexedFieldPath = (index:number) => {
    const fiedPathString = fieldPath.join('.');
    const indexedFieldPath = `${fiedPathString}[${index}]`;

    return indexedFieldPath.split('.');
  };

  return (
    <Paper component="ul" className={`${classes.root} ${disabled ? classes.rootDisabled : ''}`}>
      <div className={`${classes.chipRoot} ${disabled ? classes.chipRootDisabled : ''}`}>
        {(Boolean(handleDelete) && !disabled)
          ? (chipData?.map((data, index) => (
            <li key={data.key}>
              <Chip
                disabled={disabled}
                size="small"
                label={(
                  <HighlightText
                    fieldId={`${id}[${index}]`}
                    fieldPath={getIndexedFieldPath(index)}
                    fieldType={fieldTypes.CHIP}
                  >{data.label}
                  </HighlightText>
                )}
                onDelete={Boolean(handleDelete) ? (() => handleDelete(data)) : undefined}
                className={classes.chip}
                id={`${id}[${index}]`}
              />
            </li>
          )))
          : (
            <UniversalChip
              chipType={chipTypes.READONLY}
              arrayStrings={chipData.map((item) => item?.label)}
              id={id}
              fieldPath={fieldPath}
            />
          )}
      </div>
      {counter > 0 && (
        <div className={classes.counterRoot}>
          <Chip
            disabled={disabled}
            size="small"
            label={`+ ${counter}`}
            className={classes.counterChip}
            onClick={handleOpenDetails}
            id={id}
          />
        </div>
      )}
    </Paper>
  );
};

export default ArrayChips;
